/**
 * @desc 修改季度计划基础信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanQuarterUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/plan/quarter/updatePlanInfo',
    data,
  });
}

export function mock(
  data: defs.PlanQuarterUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/plan/quarter/updatePlanInfo',
    data,
  });
}
